import styled from '@emotion/styled';
import Alert from '@mui/material/Alert';

const StyledAlert = styled(Alert)``;

export default StyledAlert;
